
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-19757.594 -24588.998 17.996 19.658"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Group_6958","data-name":"Group 6958","transform":"translate(-20878 -24534.037)","opacity":".74"}},[_c('ellipse',{staticClass:"cls-2",attrs:{"id":"ellipse","cx":"1.916","cy":"1.916","rx":"1.916","ry":"1.916","transform":"rotate(-25 443.727 -2560.193)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"path","d":"M8.6 12.369a4.924 4.924 0 0 1-1.052 0 2.155 2.155 0 0 0-2.518 1.766c-.676 2.48-.225 4.322-1.578 5.6s-1.992 2.255-.977 3.044 3.758 1.2 5.6 1.2 4.547-.413 5.6-1.2.376-1.766-.977-3.044-.9-3.081-1.578-5.6a2.186 2.186 0 0 0-2.52-1.766z","transform":"rotate(-25 427.72 -2542.081)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"path-2","d":"M19.309 43.9a2.255 2.255 0 1 1-4.509 0","data-name":"path","transform":"rotate(-25 387.307 -2514.178)"}})])])
          )
        }
      }
    